import { FC, useEffect, useState } from 'react'
import usePreview from 'project/usePreview'
import Button from './forms/Button'
import { useRouter } from 'next/router' // we need this to make JSX compile

type PreviewType = {}

const PreviewBar: FC<PreviewType> = ({}) => {
  const { preview, setPreview } = usePreview()
  const [ready, setReady] = useState(false)
  const router = useRouter()
  useEffect(() => {
    setReady(true)
  }, [])
  return preview && ready ? (
    <div>
      <div key='preview' className='text-center'>
        You are in preview mode.
        <Button
          onClick={() => {
            router.replace('/').then(() => {
              setPreview(false)
            })
          }}
          theme='text'
        >
          Exit
        </Button>
      </div>
    </div>
  ) : (
    <></>
  )
}

export default PreviewBar
